import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {
  AUTHENTICATION_SERVICE_TOKEN,
  USER_ROLE_SERVICE_TOKEN,
} from '../types/tokens';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard {
  private user = inject(USER_ROLE_SERVICE_TOKEN);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    { url }: RouterStateSnapshot,
  ): boolean {
    if (this.user.isAuthenticated()) return true;
    //if (url !== '/login') this.user.redirectUrl?.set(url);
    this.user.redirectAfterLogin.set(url);
    this.router.navigateByUrl('login', { state: { redirect: url } });
    return false;
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    return this.canActivate(route, state);
  }
}
